module.exports = __webpack_public_path__ + "img/ico_ranking_1st.7ad5a01d.svg";